<template>
  <div :class="['file-item', !disableClickStyle && 'clickable', item.type === 'space' && 'space-item', scenario === 'search' && 'search-item']" @click="onItemClick">
    <div class="thumb-icon">
      <thumb-icon
        :type="item.type"
        :name="item.name"
        :thumbnail="item.thumbnail"
        :space="item.space"
        :typeIcon="item.type_icon"
      />
    </div>
    <div :class="['item-main', !noBorder && 'has-border-bottom']">
      <div
        v-if="scenario === 'search' && searchItemName"
        class="item-name two-line-ellipsis"
        v-html="searchItemName"
      />
      <div v-else class="item-name two-line-ellipsis">
        {{item.name}}
      </div>
      <div v-if="scenario === 'share' && item.detect_status !== 'detect_invalid'" class="item-meta">
        <i v-if="item.is_encrypted" class="iconfont icon-file-encrypt"></i>
        {{(item.action_time === undefined) ? '' : item.action_time + $t('base.comma')}}{{item.approx_size}}
      </div>
      <div v-else-if="item.type !== 'space' && item.detect_status !== 'detect_invalid'" class="item-meta">
        <i v-if="item.is_encrypted" class="iconfont icon-file-encrypt"></i>
        {{(inTrash ? $t('delete.at') + ' ' : '') + item.action_time}}{{$t('base.comma') + item.approx_size}}
      </div>
      <div v-else-if="item.detect_status === 'detect_invalid' && judgeIsExternal" :class="['item-meta', 'sensitive-tip']">
        <i class="iconfont icon-fail"></i>{{'该文件中检测到敏感词'}}
      </div>
      <div v-else-if="item.detect_status === 'detect_invalid' && !judgeIsExternal" class="item-meta">
               {{(item.action_time === undefined) ? '' : item.action_time + $t('base.comma')}}{{item.approx_size}}
      </div>
      <div v-if="showTags" class="tag-content">
        <span v-for="tag of tags" :key="tag.id" class="tag ellipsis" v-html="tag.name"></span>
        <span v-if="tagsMoreThanTwo" class="tag-num">{{$t('file.tags.more', [item.tags.length])}}</span>
      </div>
      <div v-if="item.isTopCollabFolder" class="collab-path-content">
        <span v-if="item.isTopCollabFolder" class="ellipsis">
          {{item.root_path_for_collab ? (`来自 '${item.root_path_for_collab.name}'`) : ''}}
        </span>
      </div>
      <div v-if="scenario === 'search'" class="search-result">
        <div v-if="highlights.content" class="content">
          <div class="match-content content" v-html="escapeHTML(highlights.content, ' ')" />
          <span v-if="highlights.hit_num > 2" class="hit-num">
            {{$t('file.relatedContentCount', [highlights.hit_num])}}
          </span>
        </div>
        <div v-if="highlights.description" class="content">
          <div class="match-content description" v-html="escapeHTML($t('file.info.explain') + highlights.description, ' ')" />
        </div>
        <div v-if="highlights.creator" class="content">
          <div class="match-content ellipsis" v-html="$t('file.creator') + escapeHTML(highlights.creator, ' ')" />
        </div>
        <div v-if="highlights.editor" class="content">
          <div class="match-content ellipsis" v-html="$t('file.editor') + escapeHTML(highlights.editor, ' ')" />
        </div>
        <div v-if="highlights.tags" class="content">
          <div v-for="tag of highlights.tags" :key="tag.id" class="tag ellipsis" v-html="tag.name"></div>
        </div>
        <div v-if="highlights.parentInfo && highlights.parentInfo.name" class="content ellipsis">{{$t('file.frequent.whereIn', [highlights.parentInfo.name])}}</div>
      </div>
    </div>
    <div v-if="$route.name === 'OpenView' && disableClickStyle && item.type === 'file' && !item.selected" class="mask"></div>
    <div v-if="!hideAction" class="item-action has-border-bottom">
      <template v-if="$route.name === 'OpenView'">
        <i v-if="showDelete" class="iconfont icon-close-small" @click="handleDeleteItem"/>
        <van-checkbox
          v-else-if="item.type === 'file'"
          :value="item.selected"
          shape="round"
          :disabled="item.disabled"
          ref="checkbox"
          @click.stop="onItemClick"
        />
        <i v-else class="iconfont icon-arrow-next"/>
      </template>
      <i v-else class="iconfont icon-more" @click.stop="onMenuClick"/>
    </div>
  </div>
</template>
<script>
import { i18n } from '@/utils/i18n'
import { escapeHTML } from '@/utils/common'
import { getParentItem, checkIsExternal } from '@/utils/fileUtils'

export default {
  name: 'FileItem',
  i18n,
  components: {
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    scenario: String,
    hideAction: Boolean,
    noBorder: Boolean,
    disableClickStyle: Boolean,
    showDelete: {
      type: Boolean,
      default: false
    },
    config: Object
  },
  data () {
    return {
    }
  },
  computed: {
    judgeIsExternal () {
      return this.item.detect_status === 'detect_invalid' && this.config && this.config.isSensitiveInfoDetectEnabled && !checkIsExternal(this.item)
    },
    inTrash () {
      return this.$route.params.space === 'trash'
    },
    tagsMoreThanTwo () {
      return this.item.tags && this.item.tags.length > 2
    },
    tags () {
      return this.item.tags ? this.item.tags.slice(0, 2) : []
    },
    showTags () {
      const actionPermissions = this.item.action_permissions
      const space = this.$route.params.space
      return actionPermissions && (actionPermissions.includes('perm_view_tags') || actionPermissions.includes('perm_edit_tags')) && !['trash'].includes(space) && !['search'].includes(this.scenario) && !this.hideAction && this.tags && this.tags.length
    },
    highlights () {
      const highlights = {}
      const { content, hit_num, highlighted_description, highlighted_creator_name, action_status, highlighted_tags } = this.item
      if (content) {
        highlights.content = content
        highlights.hit_num = hit_num
      }
      if (highlighted_description) {
        highlights.description = highlighted_description
      }
      if (action_status && action_status.action_by && action_status.action_by.highlighted_name) {
        highlights.editor = action_status.action_by.highlighted_name
      }
      if (!highlights.editor && highlighted_creator_name && highlighted_creator_name.indexOf('highlight') > -1) {
        highlights.creator = highlighted_creator_name
      }
      if (highlighted_tags) {
        const tags = highlighted_tags.filter(tag => tag.highlighted)
        if (tags.length) {
          highlights.tags = tags
        }
      }
      highlights.parentInfo = getParentItem(this.item)
      return highlights
    },
    searchItemName () {
      let name = this.item.hightlight_name || this.item.highlighted_name
      if (!name) {
        return name
      }
      return name
    }
  },
  methods: {
    onItemClick () {
      if (!this.inTrash) {
        this.$emit('item-click', this.item)
      }
    },
    onMenuClick () {
      this.$emit('menu-click', this.item, ['search', 'share'].includes(this.scenario) && this.scenario)
    },
    handleDeleteItem () {
      this.$emit('delete-item')
    },
    escapeHTML: escapeHTML
  }
}
</script>

<style>
.file-list {
  & .file-item {
    & .item-main {
      & .sensitive-tip{
        color: #ff0000;
        & .icon-fail {
          color: #ff0000;
          font-size: 12px;
          margin-right:4px;
        }
      }
    }
  }
}

</style>
